import { Instagram, Facebook } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useStore } from '../../data/store';
import RnRLogo from './RnRLogo';

export default function Footer() {
  const settings = useStore((s) => s.settings);

  const anchorLinks = [
    { label: 'Lineup', href: '#lineup' },
    { label: 'Infos & Anreise', href: '#infos' },
    { label: 'Galerie', href: '#gallery' },
    { label: 'Newsletter', href: '#kontakt' },
  ];

  const handleClick = (e, href) => {
    e.preventDefault();
    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-bg-primary border-t border-divider section-padding">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-16 text-center md:text-left">
          <div>
            <div className="mb-5 flex justify-center md:justify-start">
              <RnRLogo className="h-20" />
            </div>
            <p className="font-body text-text-muted text-sm leading-relaxed mb-8">
              Das kostenlose Open-Air-Festival am Rhein. Jedes Jahr. Immer laut. Immer frei.
            </p>
            <div className="flex gap-3 justify-center md:justify-start">
              {settings?.instagram && (
                <a href={settings.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="w-11 h-11 border border-divider flex items-center justify-center text-text-muted hover:text-accent-red hover:border-accent-red transition-all">
                  <Instagram size={18} />
                </a>
              )}
              {settings?.facebook && (
                <a href={settings.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="w-11 h-11 border border-divider flex items-center justify-center text-text-muted hover:text-accent-red hover:border-accent-red transition-all">
                  <Facebook size={18} />
                </a>
              )}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-lg text-text-primary mb-5">NAVIGATION</h4>
            <nav className="space-y-3" aria-label="Footer Navigation">
              {anchorLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => handleClick(e, link.href)}
                  className="block font-body text-text-muted text-sm hover:text-accent-red transition-colors py-1"
                >
                  {link.label}
                </a>
              ))}
              <Link
                to="/bewerben"
                className="block font-body text-text-muted text-sm hover:text-accent-red transition-colors py-1"
              >
                Bands bewerben
              </Link>
            </nav>
          </div>

          <div>
            <h4 className="font-heading text-lg text-text-primary mb-5">KONTAKT</h4>
            <div className="font-body text-text-muted text-sm space-y-2">
              <p>Nicole Emmler</p>
              <p>Kirchstraße 18</p>
              <p>53557 Bad Hönningen</p>
              <p className="mt-3">
                <a href={`mailto:${settings?.contactEmail || ''}`} className="hover:text-accent-red transition-colors">
                  {settings?.contactEmail}
                </a>
              </p>
              <p className="mt-2 text-text-muted/60">prOju</p>
            </div>
          </div>
        </div>

        <div className="border-t border-divider mt-12 md:mt-16 pt-8 md:pt-10 flex flex-col sm:flex-row items-center justify-between gap-4 text-center sm:text-left">
          <p className="font-body text-text-muted text-xs">{settings?.footerCopyright}</p>
          <div className="flex gap-6">
            <Link to="/impressum" className="font-body text-text-muted text-xs hover:text-accent-red transition-colors py-1">Impressum</Link>
            <Link to="/datenschutz" className="font-body text-text-muted text-xs hover:text-accent-red transition-colors py-1">Datenschutz</Link>
          </div>
        </div>
      </div>

    </footer>
  );
}
